import DealerDashboardPanel from "./dealerDashboardPanel.container"

export default DealerDashboardPanel
